import React from "react";
import DateTimePicker from "./DatePickerWrapper";
import ErrorHandlingFormHelperText from "@civicplus/preamble-ui/lib/ErrorHandlingFormHelperText/ErrorHandlingFormHelperText";
import Range from "@civicplus/preamble-ui/lib/Range";
import DateTimeRange from "@civicplus/preamble-ui/lib/DateTimeRange/DateTimeRange";
import classNames from "classnames";
import enhanceWithValidation from "@civicplus/preamble-ui/lib/Validations";

const EnhancedDateRange = enhanceWithValidation(Range);

export const DateRangeWrapper = React.forwardRef<
  HTMLDivElement,
  Omit<React.ComponentProps<typeof DateTimeRange>, "onChange"> & {
    errorMessages: { to: string; from: string } | boolean;
    onChange: (ValueShape: unknown) => void;
  }
>((props, ref) => {
  const {
    disabled,
    error,
    errorMessages,
    format,
    fromProps,
    id,
    helperText,
    label,
    locale,
    maxValue,
    minValue,
    onBlur,
    required,
    toProps,
    value,
    pickerType,
    executeValidation,
    className,
    fullWidth,
    onChange,
    ...otherProps
  } = props;

  const errorGlobal =
    typeof error !== "boolean" ? error?.to || error?.from : error;
  const onlyErrorMessageString =
    typeof errorMessages !== "boolean" ? false : errorMessages;

  return (
    <div className="prmbl-dateTimeRange-wrapper" ref={ref}>
      <EnhancedDateRange
        {...otherProps}
        disabled={disabled}
        component={DateTimePicker}
        executeValidation={executeValidation}
        errorMessage={errorMessages}
        fromProps={{
          ...fromProps,
          errorMessage:
            typeof errorMessages !== "boolean" && errorMessages?.from,
          error: typeof error !== "boolean" && error?.from,
          minValue: fromProps?.minValue || minValue,
          maxValue: fromProps?.maxValue || maxValue,
          pickerType: pickerType,
          fullWidth: fullWidth,
        }}
        error={errorGlobal}
        id={id}
        className={classNames("prmbl-dateTimeRange", className)}
        label={label}
        onChange={onChange}
        onBlur={onBlur}
        required={required}
        toProps={{
          ...toProps,
          errorMessage: typeof errorMessages !== "boolean" && errorMessages?.to,
          error: typeof error !== "boolean" && error?.to,
          minValue: toProps?.minValue || minValue,
          maxValue: toProps?.maxValue || maxValue,
          pickerType: pickerType,
          fullWidth: fullWidth,
        }}
        value={value}
      />
      <ErrorHandlingFormHelperText
        id={id ? `${id}-datetime-range-error-handling-helper-text` : undefined}
        helperText={helperText}
        error={error as boolean}
        errorMessage={onlyErrorMessageString}
      />
    </div>
  );
});

DateRangeWrapper.displayName = "DateRangeWrapper";

export default DateRangeWrapper;
